// Internationalization Layer - locale Policy support
'use strict';
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      global.dsi18nlayer = factory()
}(this, function () {
  var LocalePolicyOption = {};
  if (typeof require === 'function') {
    LocalePolicyOption = require('./localePolicy');
  }  else if (typeof localePolicy !== 'undefined') {
    // eslint-disable-next-line no-undef
    LocalePolicyOption = localePolicy;
  }
  var i18nLinks = {
    url_paths: {
      term: { _: 'company/terms-and-conditions/web' },
      iterm: { _: 'iframe/company/terms-of-use' },
      privacy: { _: 'company/privacy-policy' },
      iprivacy: { _: 'iframe/company/privacy-policy' },
      ip: { _: 'IP' },
      iip: { _: 'iframe/IP' },
      ariadnext_aes: { _: 'conditions-generales-d-utilisation/GTU-ID-Check-for-AES-EN' },
      ariadnext_qes: { _: 'conditions-generales-d-utilisation/GTU-ID-Check-In-Person-for-QES-EN' },
      idv_eu_adv: { _: 'conditions-generales-d-utilisation/GTU-EU-Advanced-with-IDV-EN' }
    },
    baseURL_keys: {
      ariadnext_aes: 'fr',
      ariadnext_qes: 'fr',
      idv_eu_adv: 'fr'
    },
    countryToLanguage: {},
    baseURLs: {
      fr: 'https://www.docusign.fr/',
      _: 'https://www.docusign.com/'
    }
  };
  if (typeof require === 'function') {
    i18nLinks = require('./i18nlink');
  }  else if (typeof i18nlink !== 'undefined') {
    // eslint-disable-next-line no-undef
    i18nLinks = i18nlink;
  }

  // return base locale policy of specified language defined by server side
  function _getBaseLocalePolicy(lang, predefinedPolicy, baseLocalePolicy) {
    var k, policy;
    policy = {cultureName: lang};
    for ( k in baseLocalePolicy ) {
      policy[k] = baseLocalePolicy[k];
    }
    var predefined = predefinedPolicy
      .filter(function (obj) {
        return obj.cultureName === lang;
      })[0];
    for ( k in predefined ) {
      policy[k] = predefined[k];
    }
    return policy;
  }

  function getSupportedCultureName(languageOrRegion, regionOnly) {
    var region = languageOrRegion ? languageOrRegion.replace('-', '_').toLowerCase() : 'en';
    if (LocalePolicyOption.languageToRegion[region] ||
      LocalePolicyOption.predefinedPolicyV2
        .find(function (obj) {
          return obj.cultureName === region;
        })) {
      return regionOnly ?
        LocalePolicyOption.languageToRegion[region] || region :
        region; // supported language or region
    }
    if (region.length > 2 && region[2] === '_' &&
      LocalePolicyOption.languageToRegion[region.substr(0, 2)]) {
      var fallback = region.substr(0, 2);
      return regionOnly ?
        LocalePolicyOption.languageToRegion[fallback] :
        fallback; // fallback language
    }
    return regionOnly ? 'en_us' : 'en';
  }

  function getBaseLocalePolicyV1(language) {
    var lang = getSupportedCultureName(language);
    return _getBaseLocalePolicy(lang, LocalePolicyOption.predefinedPolicy, LocalePolicyOption.baseLocalePolicy);
  }

  function getRegionLocalePolicy(languageOrRegion) {
    var region = getSupportedCultureName(languageOrRegion, true);
    return _getBaseLocalePolicy(region, LocalePolicyOption.predefinedPolicyV2, LocalePolicyOption.baseLocalePolicyV2);
  }


  // return true: ascii non-alphanumeric
  function isNotAlphaNumeric(c) {
    return (c < 0x30) || (c >= 0x3a && c <= 0x40) || (c >= 0x5b && c <= 0x60) || (c >= 0x7b && c <= 0x7f);
  }

  // return true: CJK
  function isCJKChar(c) {
    return (c >= 0x3000 && c <= 0x9fcc);
  }

  function isLetter(c) {
    // This allows all actual letters from non CJK and explicitly allows all CJK characters
    return c.toLowerCase() != c.toUpperCase() || isCJKChar(c.charCodeAt(0));
  }

  // return true: all characters are in CJK or non-Alphanumeric
  function isCJKString(text) {
    for ( var i in text ) {
      if (!isNotAlphaNumeric(text.charCodeAt(i)) && !isCJKChar(text.charCodeAt(i))) {
        return false;
      }
    }
    return true;
  }

  function joinNames(nameArr, separator) {
    nameArr = nameArr || [];
    return nameArr
      .filter(function (str) {
        return str && str.length > 0;
      })
      .join(separator);
  }

  // get Full name from First, Middle and Last name
  function formatName(localePolicy, firstName, middleName, lastName) {
    return this.formatFullName(localePolicy, '', firstName, middleName, lastName, '');
  }

  // get Full name from title, First, Middle, Last and suffix
  function formatFullName(localePolicy, title, firstName, middleName, lastName, suffix) {
    localePolicy = localePolicy || {};
    title = title ? title.trim() : '';
    firstName = firstName ? firstName.trim() : '';
    middleName = middleName ? middleName.trim() : '';
    lastName = lastName ? lastName.trim() : '';
    suffix = suffix ? suffix.trim() : '';
    var formatter = getNameFormatter(LocalePolicyOption.nameFormatters, firstName + lastName,
      localePolicy.effectiveNameFormat, 'full');
    var fullName = '';
    if (formatter.lastfirst) {
      fullName = joinNames([title, lastName, middleName, firstName, suffix], formatter.separator);
    } else if (formatter.numN === 3) {
      fullName = joinNames([firstName, middleName, lastName], formatter.separator);
    } else { // Full
      fullName = joinNames([title, firstName, middleName, lastName, suffix], formatter.separator);
    }
    return fullName.trim();
  }

  // get name format
  function getFullName(localePolicy, firstName, lastName) {
    firstName = firstName ? firstName.trim() : '';
    lastName = lastName ? lastName.trim() : '';
    var formatter = LocalePolicyOption.nameFormatters[localePolicy.effectiveNameFormat];
    var fullName;
    if (formatter.lastfirst) {
      fullName = lastName + formatter.separator + firstName
    } else {
      fullName = firstName + formatter.separator + lastName
    }
    return fullName;
  }

  function getInputOrder(localePolicy) {
    var formatter = LocalePolicyOption.nameFormatters[localePolicy.effectiveNameFormat];
    if (formatter.lastfirst) {
      return 'lastfirst';
    } else {
      return 'firstlast';
    }
  }

  function getNameFormatter(fomatters, fullname, key, defvalue) {
    var formatter;
    formatter = fomatters[key];
    if (formatter.cjk_validate && !isCJKString(fullname)) {
      formatter = fomatters[defvalue];
    }
    return formatter;
  }

  function getNchar(name, nchar, secondary) {
    var initial;
    initial = name.substring(0, nchar);
    if (initial === '') {
      initial = secondary.substring(0, nchar);
    }
    return initial;
  }

  function getAllInitials(names) {
    // Original code of getInitialsFromName() in signing app is gathering
    // first characters from each token word.
    // so if user input 'title first middle last suffix', Initials is 'tfmls'

    var alphaInitials = '';
    var allInitials = '';
    for (var i = 0; i < names.length; i++) {
      if (names[i].length) {
        allInitials += names[i][0];

        if (isLetter(names[i][0])) {
          alphaInitials += names[i][0];
        }
      }
    }

    if (alphaInitials.length >= 2) {
      return alphaInitials;
    }

    return allInitials;
  }


  function getNames(names, nameFormatter) {

    var firstToken = '';
    var lastToken = '';

    if (names && names.length > 0) {
      firstToken = names[0];
    }

    if (names && names.length > 1) {
      for (var x = names.length - 1; x > 0; x--) {
        if (names[x].length && isLetter(names[x][0])) {
          lastToken = names[x];
          break;
        }
      }

      if (lastToken.length == 0) {
        // We didn't find a "letter", but there's more than one token, so fall back to previous functionality
        lastToken = names[names.length - 1];
      }
    }

    if (nameFormatter && nameFormatter.lastfirst) {
      return { firstName: lastToken, lastName: firstToken };
    }

    return { firstName: firstToken, lastName: lastToken };
  }

  // get Initials from first, last name
  function getInitials(localePolicy, firstName, lastName, isSigning) {
    localePolicy = localePolicy || {};
    var formatter, initial;
    firstName = firstName ? firstName.trim() : '';
    lastName = lastName ? lastName.trim() : '';
    initial = '';
    var formatter, initial;

    formatter = getNameFormatter(LocalePolicyOption.initialFormatters, firstName + lastName,
      localePolicy.effectiveInitialFormat, 'first1last1');
    initial = '';
    if (formatter.firstN > 0 && formatter.lastN > 0) {
      if (isSigning) {
        initial = getAllInitials(firstName.split(' '));
        initial += lastName.substring(0, 1);
      } else {
        initial = firstName.substring(0, formatter.firstN) + lastName.substring(0, formatter.lastN);
        if (lastName === '') {
          initial = initial + firstName.substring(0, formatter.firstN);
        } else if (firstName === '') {
          initial = initial + lastName.substring(0, formatter.lastN);
        }
      }
    } else if (formatter.firstN > 0) {
      initial = getNchar(firstName, formatter.firstN, lastName);
    } else if (formatter.lastN > 0) {
      initial = getNchar(lastName, formatter.lastN, firstName);
    }
    return initial.toUpperCase();
  }

  // get Initials from full name
  function getInitialsFromFullName(localePolicy, fullname, isSigning) {
    localePolicy = localePolicy || {};
    var fullname = fullname ? fullname.trim() : '';
    var names = fullname.split(' ');
    var formatter = getNameFormatter(LocalePolicyOption.nameFormatters, fullname, localePolicy.effectiveNameFormat, 'full');
    var parsedNames = getNames(names, formatter);

    if (!formatter.lastfirst) {
      var initialformatter = getNameFormatter(LocalePolicyOption.initialFormatters, fullname, localePolicy.effectiveInitialFormat, 'first1last1');
      if (initialformatter.firstN > 0 && initialformatter.lastN > 0 && isSigning) {
        return getAllInitials(names).toUpperCase();
      }
    }

    return getInitials(localePolicy, parsedNames.firstName, parsedNames.lastName, isSigning);
  }

  // get address format
  function getAddressFormat(localePolicy) {
    localePolicy = localePolicy || {};
    return localePolicy.effectiveAddressFormat;
  }

  // Date/Time format Support
  function cultureNameToLanguage(cultureName) {
    if (cultureName.indexOf('zh') === 0) return cultureName;
    return cultureName.substr(0,2);
  }

  function getTimezoneInfo(localePolicy, isSigning) {
    var timezone = isSigning ? localePolicy.timeZone : localePolicy.effectiveTimeZone;
    return LocalePolicyOption.timeZones[parseInt(timezone.substr(3, 2)) - 1];
  }

  function getDateFormat(localePolicy, isSigning) {
    var dateFormat = isSigning ? localePolicy.dateFormat : localePolicy.effectiveDateFormat;
    var dateformatlist = LocalePolicyOption.dateFormat[dateFormat];
    var format = dateformatlist[cultureNameToLanguage(localePolicy.cultureName)] || dateformatlist['_'];
    if (format === 'custom') {
      format = isSigning ? localePolicy.customDateFormat : localePolicy.effectiveCustomDateFormat;
    }
    return format;
  }

  function getDateFormatString(dateFormatEnum, lang) {
    var dateFormatList = LocalePolicyOption.dateFormat[dateFormatEnum];
    return dateFormatList[cultureNameToLanguage(lang)] || dateFormatList['_'] || 'default';
  }

  function getTimeFormat(localePolicy, isSigning) {
    var timeFormat = isSigning ? localePolicy.timeFormat : localePolicy.effectiveTimeFormat
    var format = LocalePolicyOption.timeFormat[timeFormat];
    if (timeFormat === 'custom') {
      format = isSigning ? localePolicy.customTimeFormat : localePolicy.effectiveCustomTimeFormat;
    }
    return format;
  }

  function getTimeFormatString(timeFormatEnum) {
    return  LocalePolicyOption.timeFormat[timeFormatEnum];
  }

  function getCalendarType(localePolicy, isSigning) {
    return isSigning ? localePolicy.calendarType : localePolicy.effectiveCalendarType;
  }

  function getJapaneseEra(year, month, day) {
    var datestr = year.toString() + to2Digit(month) + to2Digit(day);
    for ( var i in LocalePolicyOption.JapaneseEraInfo ) {
      if (datestr >= LocalePolicyOption.JapaneseEraInfo[i].startDate) {
        return LocalePolicyOption.JapaneseEraInfo[i];
      }
    }
    return { year: 0, yyyy: '', jaYyyy: 'UNK' };
  }

  function getJapaneseEraYear(year, month, day) {
    var era = getJapaneseEra(year, month, day);
    var eraYear = year - era.year + 1;
    var yStr = (eraYear === 1) ? yStr = '\u5143' : eraYear.toString();
    return { year: eraYear, yyyy: era.yyyy + eraYear, jaYyyy: era.jaYyyy + yStr }
  }

  function to2Digit(v) {
    if (v < 10) return '0' + v.toString();
    return v.toString();
  }

  function addEscape(format) {
    return format.replace(/(.)/g, '\\$1');
  }

  var regxBK = new RegExp('\b', 'g');

  function replaceDigit(format, digit, regxesc, regx2, regx, escape) {
    return format.replace(regxesc, '\b').replace(regx2, to2Digit(digit)).replace(regx, digit.toString()).replace(regxBK,
      escape);
  }

  function dateTimeFormatToString(format, d, culture, isJapanese) {
    if (d.constructor.name === 'Moment') {
      d = d._d;
    }
    var formatted = format;
    var digit;
    formatted = formatted.replace(/\\y/g, '\b');
    if (isJapanese) {
      var era = getJapaneseEraYear(d.getFullYear(), d.getMonth() + 1, d.getDate());
      var yyyy = (formatted.indexOf('\u5e74') >= 0) ? era.jaYyyy : era.yyyy;
      formatted = formatted.replace(/yyyy/g, addEscape(yyyy));
      digit = era.year;
    } else {
      formatted = formatted.replace(/yyyy/g, d.getFullYear().toString());
      digit = (d.getFullYear() % 100);
    }
    formatted = replaceDigit(formatted, digit, /\\y/g, /yy/g, /y/g, '\\y');
    formatted = replaceDigit(formatted, d.getHours(), /\\H/g, /HH/g, /H/g, '\\H');
    formatted = replaceDigit(formatted, (d.getHours() > 12) ? (d.getHours() - 12) : (d.getHours()), /\\h/g, /hh/g, /h/g,
      '\\h');
    formatted = replaceDigit(formatted, d.getMinutes(), /\\m/g, /mm/g, /m/g, '\\m');
    formatted = replaceDigit(formatted, d.getSeconds(), /\\s/g, /ss/g, /s/g, '\\s');

    culture = getSupportedCultureName(culture, true);
    var dateFormatLocalesInfo = LocalePolicyOption.dateFormatLocalesInfo;
    formatted = formatted.replace(/\\M/g, '\b');
    formatted = formatted.replace(/MMMM/g,
      addEscape((dateFormatLocalesInfo[culture + '.month'] || dateFormatLocalesInfo['en.month'])[d.getMonth()]));
    formatted = formatted.replace(/MMM/g,
      addEscape((dateFormatLocalesInfo[culture + '.mshort'] || dateFormatLocalesInfo['en.mshort'])[d.getMonth()]));
    formatted = replaceDigit(formatted, d.getMonth() + 1, /\\M/g, /MM/g, /M/g, '\\M');

    formatted = formatted.replace(/\\d/g, '\b')
    formatted = formatted.replace(/dddd/g,
      addEscape((dateFormatLocalesInfo[culture + '.days'] || dateFormatLocalesInfo['en.days'])[d.getDay()]));
    formatted = formatted.replace(/ddd/g,
      addEscape((dateFormatLocalesInfo[culture + '.dayshort'] || dateFormatLocalesInfo['en.dayshort'])[d.getDay()]));
    formatted = replaceDigit(formatted, d.getDate(), /\\d/g, /dd/g, /d/g, '\\d');

    formatted = formatted.replace(/\\t/g, '\b')
    formatted = formatted.replace(/tt/g, addEscape(
      (dateFormatLocalesInfo[culture + '.ampm'] || dateFormatLocalesInfo['en.ampm'])[(d.getHours() >= 12) ? (1) :
        (0)]));
    formatted = formatted.replace(/t/g, addEscape(
      (dateFormatLocalesInfo[culture + '.ampmshort'] || dateFormatLocalesInfo['en.ampmshort'])[(d.getHours() >= 12) ?
        (1) : (0)]));
    formatted = formatted.replace(regxBK, '\\t');
    return formatted.replace(/\\(?!\\)/g, '').replace(/\\\\/g, '\\');
  }

  function _formatDate(localePolicy, date, isSigning, withoutTZ) {
    if (date.constructor.name === 'Moment') {
      date = date._d;
    }
    var timeFormat = getTimeFormat(localePolicy, isSigning);
    timeFormat = timeFormat ? (' | ' + timeFormat) : '';
    var datetimeFormat = getDateFormat(localePolicy, isSigning) + timeFormat;
    var newUtc = date;
    if (!withoutTZ) {
      var utcOffset = getTimezoneInfo(localePolicy, isSigning).utcOffset;
      newUtc = new Date(date.getTime() + (date.getTimezoneOffset() * 60000) + (utcOffset * 60 * 60 * 1000));
    }
    var isJapanese = getCalendarType(localePolicy, isSigning) === 'japanese';
    return dateTimeFormatToString(datetimeFormat, newUtc, localePolicy.cultureName || 'en', isJapanese);
  }

  function formatSignedDate(localePolicy, date, withoutTZ) {
    return _formatDate(localePolicy, date, true, withoutTZ);
  }

  function formatDate(localePolicy, date, withoutTZ) {
    return _formatDate(localePolicy, date, false, withoutTZ);
  }

  function dNet2moment(dnetkey) {
    var momentformat = dnetkey;
    momentformat = momentformat.replace(/longformat|LongFormat/g, 'LL');
    momentformat = momentformat.replace(/\\d/g, '\b').replace(/d/g, 'D').replace(regxBK, '\\d');
    momentformat = momentformat.replace(/\\y/g, '\b').replace(/y/g, 'Y').replace(regxBK, '\\y');
    momentformat = momentformat.replace(/\\t/g, '\b').replace(/tt/g, 'a').replace(regxBK, '\\t');
    momentformat = momentformat.replace(/\\(.)/g, '[$1]');
    return momentformat;
  }

  // Currecny Support
  function getCurrencySymbol(localePolicy) {
    return LocalePolicyOption.currencyISOtoSymbol[localePolicy.effectiveCurrencyCode] || '$';
  }

  function getNumberFormatInfo(localePolicy, isPositive) {
    var effectiveCurrencyFormat = (isPositive ? localePolicy.effectiveCurrencyPositiveFormat :
      localePolicy.effectiveCurrencyNegativeFormat) || 'default';
    return LocalePolicyOption.currencyNumberFormatInfo[effectiveCurrencyFormat];
  }

  function formatDigit(n, decPlaces, thouSeparator, decSeparator) {
    var i, j;
    if (decPlaces === 0) {
      n = Math.floor(n);
    } else {
      n = n.toFixed(decPlaces);
    }
    i = parseInt(n) + '';
    j = (j = i.length) > 3 ? j % 3 : 0;
    return (j ? i.substr(0, j) + thouSeparator : '') + i.substr(j).replace(
      /(\d{3})(?=\d)/g, '$1' + thouSeparator) + (decPlaces ?
      decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : '');
  }

  function formatDigit2(n, decPlaces, thouSeparator, decSeparator) {
    var e, i, ii, j;
    if (decPlaces === 0) {
      n = Math.floor(n);
    } else {
      n = n.toFixed(decPlaces);
    }
    i = parseInt(n) + '';
    e = i.slice(-1);
    ii = i;
    i = i.substr(0, i.length - 1);
    j = (j = i.length) > 2 ? j % 2 : 0;
    return (j ? i.substr(0, j) + thouSeparator : '') + i.substr(j).replace(
      /(\d{2})(?=\d)/g, '$1' + thouSeparator) + e + (decPlaces ?
      decSeparator + Math.abs(n - ii).toFixed(decPlaces).slice(2) : '');
  }

  function _formatCurrency(localePolicy, digit, isoCode) {
    var currencySymbol = LocalePolicyOption.currencyISOtoSymbol[isoCode] || '$';
    var decimalDigits, decimalSeparator, digitstr, groupSeparator, negativePattern, numberInfo, positivePattern;
    if (digit < 0) {
      numberInfo = getNumberFormatInfo(localePolicy, false);
      negativePattern = numberInfo.negativePattern || numberInfo.positivePattern || '$$$$n';
    } else {
      numberInfo = getNumberFormatInfo(localePolicy, true);
      positivePattern = numberInfo.positivePattern || numberInfo.negativePattern || '$$$$n';
    }
    decimalDigits = numberInfo.decimalDigits;
    if (LocalePolicyOption.currencyNoDecimalDigitsIsoCode[isoCode]) {
      decimalDigits = 0;
    }
    if (LocalePolicyOption.currency3DecimalDigitsIsoCode[isoCode]) {
      decimalDigits = 3;
    }
    decimalSeparator = numberInfo.decimalSeparator;
    groupSeparator = numberInfo.groupSeparator;
    if (numberInfo.groupDigits === 2) {
      digitstr = formatDigit2(Math.abs(digit), decimalDigits, groupSeparator, decimalSeparator);
    } else {
      digitstr = formatDigit(Math.abs(digit), decimalDigits, groupSeparator, decimalSeparator);
    }
    if (digit < 0) {
      digitstr = negativePattern.replace('n', digitstr).replace('$', currencySymbol);
    } else {
      digitstr = positivePattern.replace('n', digitstr).replace('$', currencySymbol);
    }
    return digitstr;
  }

  function formatCurrency(localePolicy, value, isoCode, isLongFormat) {
    isoCode = isoCode ? isoCode.toLowerCase() : localePolicy.effectiveCurrencyCode;
    if (typeof value == 'string') {
      value = Number(value.replace(/[^\d^.^-]/gi, ''));
    }
    var formatted = _formatCurrency(localePolicy, value, isoCode);
    if (isLongFormat) {
      formatted = formatted + ' ' + isoCode.toUpperCase();
    }
    return formatted;
  }

  function formatNumber(localePolicy, value, decPlaces) {
    var digit = value;
    if (typeof value == 'string') {
      digit = Number(value.replace(/[^\d^.^-]/gi, ''));
    }
    var numberInfo = getNumberFormatInfo(localePolicy, true);
    var digitstr;
    if (numberInfo.groupDigits === 2) {
      digitstr = formatDigit2(Math.abs(digit), decPlaces, numberInfo.groupSeparator, numberInfo.decimalSeparator);
    } else {
      digitstr = formatDigit(Math.abs(digit), decPlaces, numberInfo.groupSeparator, numberInfo.decimalSeparator);
    }
    if (digit < 0 && digitstr.indexOf('-') < 0) {
      digitstr = '-' + digitstr;
    }
    return digitstr;
  }

  function parseCurrency(localePolicy, text) {
    var value = text.replace(/-\(\)/g, '');
    var positive = value === text;
    var numberInfo = getNumberFormatInfo(localePolicy, positive);
    if (!numberInfo) return null;
    var regx2Digit = new RegExp('[^\\d' + numberInfo.decimalSeparator + ']', 'g');
    value = value.replace(regx2Digit, '');
    value = value.replace(numberInfo.decimalSeparator.toString(), '.');
    var number = Number(value);
    return (positive) ? number : -number;
  }

  function getParseDatePattern(localePolicy) {
    var dateFormat = getDateFormat(localePolicy, false);
    var pattern = 'mdy';
    if (dateFormat.indexOf('y') === 0) {
      pattern = 'ymd';
    } else if (dateFormat.indexOf('d') === 0) {
      pattern = 'dmy';
    }
    return LocalePolicyOption.dateParsePattern[pattern];
  }

  function replaceMonthNames(localePolicy, text) {
    var result = text;
    var culture = getSupportedCultureName(localePolicy.cultureName, true);
    var monthnames = LocalePolicyOption.dateFormatLocalesInfo[culture + '.month'];
    if (!monthnames) return result;
    if (culture === 'cs_cz' || culture === 'vi_vn') {
      for ( var m = 11; m >= 0; m-- ) {
        result = result.replace(monthnames[m], (m + 1).toString());
      }
    } else {
      for ( var m = 0; m < 12; m++ ) {
        result = result.replace(monthnames[m], (m + 1).toString());
      }
    }
    monthnames = LocalePolicyOption.dateFormatLocalesInfo[culture + '.mshort'];
    if (!monthnames) return result;
    for ( var m = 0; m < 12; m++ ) {
      result = result.replace(monthnames[m], (m + 1).toString());
    }
    result = result.replace(/de/g, ' ')
    // console.log(result);
    return result;
  }

  function parseDate(localePolicy, text, yearRequired) {
    yearRequired = yearRequired || false;
    var pattern = getParseDatePattern(localePolicy);
    var regex = new RegExp(pattern.regx);
    var r = regex.exec(text);
    if (!r) {
      r = regex.exec(replaceMonthNames(localePolicy, text));
    }
    if (!r) return null;
    var mm = r[pattern.m[0]] || r[pattern.m[1]] || r[pattern.m[2]];
    var dd = r[pattern.d[0]] || r[pattern.d[1]] || r[pattern.d[2]];
    var yy = r[pattern.y[0]];
    if (yearRequired && (!yy || yy < 100)) {
      return null;
    }
    if (!yy) {
      yy = (new Date()).getFullYear();
    }    else if (yy < 100) {
      yy = '20' + yy;
    }
    // console.log('mm=' + mm);
    // console.log('dd=' + dd);
    // console.log('yy=' + yy);
    return {m: mm, d: dd, y: yy};
  }

  function getMetaData(localePolicy, prop, withunset, option) {
    var meta = LocalePolicyOption.metaData[prop];
    var result = [];
    if (!localePolicy) localePolicy = {};
    var policy = {
      cultureName: localePolicy.cultureName || 'en', effectiveDateFormat: '',
      effectiveTimeFormat: '', effectiveCalendarType: localePolicy.effectiveCalendarType || 'gregorian',
      effectiveCurrencyCode: localePolicy.effectiveCurrencyCode || 'usd', effectiveCurrencyPositiveFormat: '',
      effectiveCurrencyNegativeFormat: ''
    };
    if (withunset) {
      result.push({value: 'unset', display: 'Unset'});
    }
    if (prop === 'timeFormat') {
      var date = option;
      for ( var j in meta ) {
        policy.effectiveTimeFormat = meta[j].value;
        var format = getTimeFormat(policy, false);
        if (!format)
          format = 'None';
        var display = dateTimeFormatToString(format, date, policy.cultureName, false);
        if (format !== 'None') {
          display = display + ' (' + format + ')';
        }
        result.push({value: meta[j].value, display: display});
      }
    } else if (prop === 'dateFormat') {
      var date = option;
      var isJapanese = false;
      if (policy.effectiveCalendarType === 'japanese')
        isJapanese = true;
      for ( var j in meta ) {
        policy.effectiveDateFormat = meta[j].value;
        var format = getDateFormat(policy, false);
        var display = dateTimeFormatToString(format, date, policy.cultureName, isJapanese);
        display = display + ' (' + format + ')';
        result.push({value: meta[j].value, display: display});
      }
    } else if (prop === 'currencyPositiveFormat') {
      for ( var j in meta ) {
        policy.effectiveCurrencyPositiveFormat = meta[j].value;
        result.push(
          {value: meta[j].value, display: formatCurrency(policy, 123456789, policy.effectiveCurrencyCode, false)});
      }
    } else if (prop === 'currencyNegativeFormat') {
      for ( var j in meta ) {
        policy.effectiveCurrencyNegativeFormat = meta[j].value;
        result.push(
          {value: meta[j].value, display: formatCurrency(policy, -123456789, policy.effectiveCurrencyCode, false)});
      }
    } else {
      for ( var j in meta ) {
        result.push({value: meta[j].value, display: meta[j].display});
      }
    }
    return result;
  }

  function setup(dependencies) {
    // No dependency
  }

  // We are adding (|by DocuSign) to the regex to indicate this is something added by DocuSign and not by the customer
  var DEFAULT_DATETEXTTAB_REGEX = '^(|by DocuSign)((|0)[1-9]|1[0-2])/((|0)[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$';

  function getDocuSignDateTextTabFormats(pattern) {
    return docuSignDateTextTabFormats[pattern];
  }

  function isDocuSignValidationPattern(pattern) {
    if (getDocuSignDateTextTabFormats(pattern) !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  // We are adding (|by DocuSign) to the regex to indicate this is something added by DocuSign and not by the customer
  var docuSignDateTextTabFormats = {
    '^(|by DocuSign)((|0)[1-9]|1[0-2])/((|0)[1-9]|[1-2][0-9]|3[0-1])/[0-9]{4}$': { format: 'MM/dd/yyyy', customInvalidDate: 'Date', helpfulMessageDate: 'DocuSign_HelpfulMessageDate' },
    '^(|by DocuSign)((|0)[1-9]|[1-2][0-9]|3[0-1])/((|0)[1-9]|1[0-2])/[0-9]{4}$': { format: 'dd/MM/yyyy', customInvalidDate: 'Date_DDMMYYYY', helpfulMessageDate: 'DocuSign_HelpfulMessageDate_DDMMYYYY' },
    '^(|by DocuSign)[0-9]{4}/((|0)[1-9]|1[0-2])/((|0)[1-9]|[1-2][0-9]|3[0-1])$': { format: 'yyyy/MM/dd', customInvalidDate: 'Date_YYYYMMDD', helpfulMessageDate: 'DocuSign_HelpfulMessageDate_YYYYMMDD' }
  };

  function getDateTextTabValidationForFormat(formatString) {
    for (var key in docuSignDateTextTabFormats) {
      if (docuSignDateTextTabFormats[key].format === formatString)
        return key
    }
    return DEFAULT_DATETEXTTAB_REGEX;
  }

  function getDefaultDateTextTabValidation(localePolicy) {
    var defaultDateTextTabValidation = DEFAULT_DATETEXTTAB_REGEX;
    var effectiveDateFormat = getDateFormat(localePolicy, false);
    if (effectiveDateFormat.match(/^(d|D)/)) {
      defaultDateTextTabValidation = getDateTextTabValidationForFormat('dd/MM/yyyy')
    } else if (effectiveDateFormat.match(/^(m|M)/)) {
      defaultDateTextTabValidation = getDateTextTabValidationForFormat('MM/dd/yyyy')
    } else if (effectiveDateFormat.match(/^(y|Y)/)) {
      defaultDateTextTabValidation = getDateTextTabValidationForFormat('yyyy/MM/dd')
    }
    return defaultDateTextTabValidation;
  }

  var NUMBER_WITH_COMMA_DECIMAL_SEPARATOR_REGEX = '^-?\\d{0,}(\\,\\d{1,})?$';

  function getDefaultNumberDecimalValidation(localePolicy) {
    return getNumberFormatInfo(localePolicy, true)
      .decimalSeparator === '.'
      ? ''
      : NUMBER_WITH_COMMA_DECIMAL_SEPARATOR_REGEX;
  }

  function localizeURL(url, language) {
    if (language === 'en') return url;
    var radminNewDocUrl = 'https://www.docusign.com/support/new/documentation/ndse-admin-guide/';
    if (url.toLowerCase().indexOf(radminNewDocUrl) === 0) {
      var key = url.replace(radminNewDocUrl, '');
      url = 'https://support.docusign.com/guides/ndse-admin-guide-' + (i18nLinks.radmin_new_doc_to_guide_map[key] || key);
    }
    for (var i in i18nLinks.to_be_localized_pages) {
      var info = i18nLinks.to_be_localized_pages[i];
      for (var j in info.url_paths) {
        if (url.toLowerCase().indexOf(info.base_url + info.url_paths[j].toLowerCase()) === 0) {
          var languageTo = i18nLinks.replace_language_to[info.languages] || i18nLinks.replace_language_to['_'];
          var lang = languageTo[language] || languageTo['_'];
          var replacement = info.replacement.replace('{lang}', lang);
          return url.replace(info.regex, replacement);
        }
      }
    }
    for (var i in i18nLinks.localized_license_pages) {
      var info = i18nLinks.localized_license_pages[i];
      for (var path in info.url_paths) {
        if (url.toLowerCase().indexOf(info.base_url + path.toLowerCase()) === 0) {
          return info.url_paths[path];
        }
      }
    }
    return url;
  }

  function getLink(topic, language) {
    var lang = (language || 'en').replace('-', '_').toLowerCase();
    if (topic && topic.indexOf('https://') === 0) {
      var result = localizeURL(topic, lang);
      if (lang === 'en' || result.indexOf('https://') === 0) {
        return result;
      }
      topic = result; // try topic by the result
    }
    var paths = i18nLinks.url_paths[topic] || i18nLinks.url_paths['term'];
    if (paths[lang]) {
      return i18nLinks.baseURLs[lang] + paths[lang];
    }
    return i18nLinks.baseURLs[i18nLinks.baseURL_keys[topic] || '_'] + paths['_'];
  }

  function getLocalizableURLs() {
    var localizableList = [];
    for (var key in i18nLinks.baseURLs) {
      if (localizableList.indexOf(i18nLinks.baseURLs[key]) < 0 ) {
        localizableList.push(i18nLinks.baseURLs[key]);
      }
    }
    return localizableList;
  }

  function getListFormatter(formatters, language, style, type) {
    var formatter;
    var selectedFormatters;
    language = getSupportedCultureName(language, false);
    if (style === 'short' && type === 'unit') {
      selectedFormatters = formatters.unitShort;
    } else if (style === 'long' && type === 'conjunction') {
      selectedFormatters = formatters.conjunctionLong;
    } else if (style === 'short' && type === 'conjunction') {
      selectedFormatters = formatters.conjunctionShort;
    } else {
      throw('Not implemented.');
    }
    if (language in selectedFormatters) {
      formatter = selectedFormatters[language]
      formatter.start = formatter.start || selectedFormatters.default.start;
      formatter.middle = formatter.middle || selectedFormatters.default.middle;
      formatter.end = formatter.end || selectedFormatters.default.end;
      formatter.two = formatter.two || selectedFormatters.default.two;
    } else {
      formatter = selectedFormatters.default;
    }
    return formatter;
  }

  function formatList(language, style, type, items) {
    var formatter;
    // Special cases 0, 1, 2 items
    if (items === null || items.length === 0) {
      return '';
    } else if (items.length === 1) {
      return items[0];
    } else if (items.length === 2) {
      formatter = getListFormatter(LocalePolicyOption.listFormatters, language, style, type);
      return formatter.two.replace(/\{0\}/, items[0]).replace(/\{1\}/, items[1]);
    }

    formatter = getListFormatter(LocalePolicyOption.listFormatters, language, style, type);
    // Add first two items
    var formattedList = formatter.start.replace(/\{0\}/, items[0]).replace(/\{1\}/, items[1]);
    var i;
    for (i = 2; i < items.length; i++) {
      // Only one item left to add
      if (i === items.length - 1) {
        formattedList = formatter.end.replace(/\{0\}/, formattedList).replace(/\{1\}/, items[i]);
        break;
      } else {
        formattedList = formatter.middle.replace(/\{0\}/, formattedList).replace(/\{1\}/, items[i])
      }
    }
    return formattedList;
  }

  return {
    setup: setup,
    formatName: formatName,
    formatFullName: formatFullName,
    getFullName: getFullName,
    getInputOrder: getInputOrder,
    getInitials: getInitials,
    getInitialsFromFullName: getInitialsFromFullName,
    getLocalePolicy: getBaseLocalePolicyV1,
    getRegionLocalePolicy: getRegionLocalePolicy,
    isCJKString: isCJKString,
    isLetter: isLetter,
    getAddressFormat: getAddressFormat,
    getSupportedCultureName: getSupportedCultureName,

    getCurrencySymbol: getCurrencySymbol,
    getNumberFormatInfo: getNumberFormatInfo,
    formatCurrency: formatCurrency,
    formatNumber: formatNumber,

    getJapaneseEraYear: getJapaneseEraYear,
    formatDate: formatDate,
    formatSignedDate: formatSignedDate,
    dateTimeFormatToString: dateTimeFormatToString,
    getDateFormat: getDateFormat,
    getTimeFormat: getTimeFormat,
    getDateFormatString: getDateFormatString,
    getTimeFormatString: getTimeFormatString,
    dNet2moment: dNet2moment,

    getMetaData: getMetaData,
    parseCurrency: parseCurrency,
    parseDate: parseDate,
    DEFAULT_DATETEXTTAB_REGEX: DEFAULT_DATETEXTTAB_REGEX,
    getDocuSignDateTextTabFormats: getDocuSignDateTextTabFormats,
    isDocuSignValidationPattern: isDocuSignValidationPattern,
    docuSignDateTextTabFormats: docuSignDateTextTabFormats,
    getLink: getLink,
    getLocalizableURLs: getLocalizableURLs,
    NUMBER_WITH_COMMA_DECIMAL_SEPARATOR_REGEX: NUMBER_WITH_COMMA_DECIMAL_SEPARATOR_REGEX,
    getDefaultDateTextTabValidation: getDefaultDateTextTabValidation,
    getDefaultNumberDecimalValidation: getDefaultNumberDecimalValidation,
    formatList: formatList,
  };

}));
